export default __webpack_public_path__ + "static/academicons-81999d33018c0cad9e41ae220fd250a4.woff";